/* ============================================================
   タスクル 通常ページ（無印、/gomiyashiki等）リニューアル版
   2026-11-02〜: デザイン/2026年10月/タスクル_通常ページ全面リニューアル/01_仕様.md。
   03_モック_通常ページ_*.htmlに埋め込まれていた#nk-js（業者カードの並び替え・料金切り替え）・
   タブの現在地ハイライト・チャット見本の再生ロジックをほぼそのまま移植。
   LP入力欄からの遷移（new_lp_ad2top.jsのbindCityFormと同じ考え方）には、通常ページ経由と
   分かるよう entry=organic を付ける（01_仕様.md 3.5章4）。
   ============================================================ */
(function () {
  const root = document.querySelector(".organic-lp");
  if (!root) return;

  const bootEl = document.getElementById("og-boot");
  const BOOT = bootEl ? JSON.parse(bootEl.textContent) : {};

  function trackOg(event, extra) {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push(Object.assign({ event: event, category: BOOT.category }, extra || {}));
  }

  const z2h = v => v.replace(/[０-９－]/g, c => (c === "－" ? "-" : String.fromCharCode(c.charCodeAt(0) - 0xFEE0)));

  function goToRequest(params) {
    const q = new URLSearchParams(Object.assign({ entry: "organic" }, params));
    window.location.href = BOOT.requestPath + "?" + q.toString();
  }

  let inputStarted = false;
  function trackInputStart() {
    if (inputStarted) return;
    inputStarted = true;
    trackOg("og_lp_input_start");
  }

  function bindCityForm(formEl, inputEl, errEl, posLabel) {
    if (!formEl || !inputEl) return;
    inputEl.addEventListener("input", trackInputStart);
    formEl.addEventListener("submit", e => {
      e.preventDefault();
      const raw = inputEl.value.trim();
      const v = z2h(raw);
      if (!v) {
        inputEl.style.borderColor = "#E8462B";
        inputEl.focus();
        if (errEl) errEl.style.display = "block";
        return;
      }
      if (errEl) errEl.style.display = "none";
      const isZip = /^\d{3}-?\d{4}$/.test(v);
      trackOg("og_lp_submit", { label: posLabel, method: isZip ? "zip" : "city" });
      // 01_仕様.md 1章「計測」：今のボタンID（#{category}EstimateStart）とformSubmitS1を
      // 新しい「次へ」に付ける。GTM側の既存トリガー（#formSubmitS1のクリック）が引き続き
      // 拾えるよう、実際の送信ロジックとは別に、合図用の非表示ボタンを一度だけクリックする。
      const legacySubmit = document.getElementById("formSubmitS1");
      if (legacySubmit) legacySubmit.click();
      if (isZip) {
        const zip = v.replace("-", "");
        fetch("https://zipcloud.ibsnet.co.jp/api/search?zipcode=" + zip)
          .then(res => res.json())
          .then(data => {
            const r = data.results && data.results[0];
            if (r) goToRequest({ from_lp: r.address2 || "", from_lp_pref: r.address1 || "", from_lp_addr: r.address3 || "" });
            else goToRequest({ from_lp: raw });
          })
          .catch(() => goToRequest({ from_lp: raw }));
      } else {
        goToRequest({ from_lp: raw });
      }
    });
  }
  bindCityForm(document.getElementById("og-form-top"), document.getElementById("og-city"), document.getElementById("og-city-error"), "top");
  bindCityForm(document.getElementById("og-form-bottom"), document.getElementById("og-city2"), null, "bottom");

  // 「比べる」等、入力欄へスクロール＋フォーカスするだけのCTA（ad=2のdata-tocityと同じ考え方）。
  const cityInput = document.getElementById("og-city");
  document.querySelectorAll("[data-tocity]").forEach(btn => {
    btn.addEventListener("click", e => {
      e.preventDefault();
      trackOg("og_lp_cta_click", { label: btn.textContent.replace(/\s+/g, "").trim() });
      if (cityInput) {
        cityInput.scrollIntoView({ behavior: "smooth", block: "center" });
        setTimeout(() => cityInput.focus({ preventScroll: true }), 450);
      } else {
        // サイトTOP（入力欄なし）：ファーストビューのジャンル選択（#genre）へ。
        const genre = document.getElementById("genre");
        if (genre) genre.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  });

  // 下固定バー：ファーストビューの入力カードを通り過ぎたら出す。
  (function () {
    const bar = document.getElementById("og-bar");
    const card = document.getElementById("og-top-form");
    if (!bar || !card) return;
    function upd() {
      const r = card.getBoundingClientRect();
      bar.classList.toggle("hide", r.bottom > 0);
    }
    window.addEventListener("scroll", upd, { passive: true });
    upd();
  })();

  // タブの現在地ハイライト（スクロール追従）。
  (function () {
    const tabs = [...document.querySelectorAll(".og-tabs a")];
    const bar = document.getElementById("og-tabs");
    if (!tabs.length || !bar) return;
    function upd() {
      const off = (bar.getBoundingClientRect().bottom || 0) + 40;
      let cur = null;
      tabs.forEach(a => {
        const t = document.querySelector(a.getAttribute("href"));
        if (t && t.getBoundingClientRect().top <= off) cur = a;
      });
      tabs.forEach(a => a.classList.toggle("on", a === cur));
    }
    window.addEventListener("scroll", upd, { passive: true });
    upd();
  })();

  // チャット見本：画面に入ったら1通ずつ再生（繰り返さない）。
  (function () {
    const box = document.getElementById("og-chat");
    if (!box) return;
    const ms = [...box.querySelectorAll(".lm")];
    let played = false;
    function play() {
      if (played) return;
      played = true;
      let t = 0;
      ms.forEach(m => { setTimeout(() => m.classList.add("show"), t); t += 900; });
    }
    function chk() {
      const r = box.getBoundingClientRect();
      if (r.top < innerHeight * 0.85 && r.bottom > 0) play();
    }
    window.addEventListener("scroll", chk, { passive: true });
    chk();
  })();

  // 業者一覧カード：並び替え・プラン切り替え（モックの#nk-jsをそのまま移植）。
  (function () {
    const box = document.querySelector(".nk");
    if (!box) return;
    const list = box.querySelector(".nk-list");
    // 2026-11-02〜: 業者ページ（store_page_v2）も安心の数字の表示にCSS変数スコープ用途で
    // .nkクラスを再利用しているが、そちらには.nk-listが無い（カード一覧はこのページには無い）。
    // nullガードを入れて、業者ページで本処理が落ちないようにしている。
    if (!list) return;
    const cards = [...list.querySelectorAll(".nk-card")];
    if (!cards.length) return;
    const planPrefix = list.dataset.planPrefix || "";
    const SH = { "軽トラック": "軽トラ", "2トントラック": "2t", "1.5トントラック": "1.5t" };
    const SB = { "軽トラック": "1K・家具家電10点ほど", "1.5トントラック": "ワンルーム〜1Kまるごと", "2トントラック": "1LDK〜2DKまるごと" };
    // 修正指示_第3回 D（遺品整理）1：ボタンの並びと最初に選ぶプランは、サーバーが出したボタンの順（1K→1LDK→…→4LDK、
    // 軽トラ→…）に合わせる。以前は1枚目のカードの料金の並び順になっていて、3LDKが先頭・最初に選ばれることがあった。
    const plans = [...box.querySelectorAll(".nk-chips button[data-k]")].map(b => b.dataset.k)
      .filter(k => cards.some(c => k in JSON.parse(c.dataset.p || "{}")));
    cards.forEach(c => { Object.keys(JSON.parse(c.dataset.p || "{}")).forEach(k => { if (plans.indexOf(k) < 0) plans.push(k); }); });
    if (!plans.length) return;
    let cur = plans[0], sort = "rec", open = false;
    const yen = x => x.toLocaleString() + "円〜";

    function render() {
      box.querySelector(".nk-chips").innerHTML = plans.map(k =>
        `<button type="button" data-k="${k}" class="${k === cur ? "on" : ""}">${SH[k] || k}${SB[k] ? `<small>${SB[k]}</small>` : ""}</button>`
      ).join("");
      const ps = [];
      cards.forEach(c => {
        const p = JSON.parse(c.dataset.p || "{}")[cur];
        const el = c.querySelector(".nk-price");
        el.querySelector(".l").innerHTML = planPrefix + "・" + (SH[cur] || cur) + "の基本料金" + (SB[cur] ? `<small>${SB[cur]}</small>` : "");
        el.querySelector("b").textContent = p ? yen(p) : "見積もりで案内";
        el.classList.toggle("na", !p);
        if (p) ps.push(p);
        el.classList.remove("fl"); void el.offsetWidth; el.classList.add("fl");
      });
      const minEl = box.querySelector(".nk-min");
      if (minEl) minEl.innerHTML = "掲載業者の" + (SH[cur] || cur) + "　<b>" + (ps.length ? yen(Math.min.apply(null, ps)) : "—") + "</b><small>" + ps.length + "社の基本料金から</small>";
      const R = { y: 0, r: 1, "": 2 };
      const L = cards.slice();
      L.sort((a, b) => {
        if (sort === "low") {
          const pa = JSON.parse(a.dataset.p || "{}")[cur] || 9e9, pb = JSON.parse(b.dataset.p || "{}")[cur] || 9e9;
          if (pa !== pb) return pa - pb;
        } else if (sort === "rev") {
          const d = (+b.dataset.n) - (+a.dataset.n);
          if (d) return d;
        } else {
          const r = R[a.dataset.b] - R[b.dataset.b];
          if (r) return r;
        }
        return a.dataset.o - b.dataset.o;
      });
      L.forEach((c, i) => { list.appendChild(c); c.hidden = !open && i >= 3; });
      box.querySelectorAll(".nk-sort button").forEach(b => b.classList.toggle("on", b.dataset.s === sort));
      const mb = box.querySelector(".nk-more");
      if (mb) { mb.hidden = cards.length <= 3; mb.textContent = open ? "閉じる ▲" : `ほかの業者も見る（${cards.length - 3}社）▼`; }
      box.querySelectorAll(".nk-chips button").forEach(b => b.onclick = () => { cur = b.dataset.k; render(); });
    }
    box.querySelectorAll(".nk-sort button").forEach(b => b.onclick = () => { sort = b.dataset.s; render(); });
    const moreBtn = box.querySelector(".nk-more");
    if (moreBtn) moreBtn.onclick = () => { open = !open; render(); };
    render();
  })();

  trackOg("og_lp_view");
})();
